import React, { useEffect, useState } from 'react';
import { ICreateSalesData, ItemInput } from "../../../@types";
import AddItem from '../../expense/ExpenseCreate/AddExpenseItem';
import { InvoiceErrors } from "../../../modules/validateInvoiceForm";

interface Props {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  validateCurrentStep?: () => boolean;
  validationResults:  InvoiceErrors;
  setValidationResults: React.Dispatch<React.SetStateAction<any>>;
  items: ItemInput[];
  setItems: React.Dispatch<React.SetStateAction<ItemInput[]>>;
  addItem: () => void;
  removeItem: (index: number) => void;
  updateCell: (index: number, field: string, value: string | number) => void;
  updateRow: (index: number, item: ItemInput) => void;
  selectedCurrencyLabel: string;
}

const MobileFreeForm : React.FC<Props> = ({
  formData,
  setFormData,
  validateCurrentStep,
  validationResults,
  setValidationResults,
  items,
  setItems,
  addItem,
  removeItem,
  updateCell,
  updateRow,
  selectedCurrencyLabel,
}) => {
    const [isOpen, setIsOpen] = useState(false);
      const [editItem, setEditItem] = useState<ItemInput | undefined>(undefined);
      const [isEdit, setIsEdit] = useState(false);
      const [total, setTotal] = useState<number>(0);
    
    
      
    
      useEffect(() => {
        // Clear validation errors on update
        setValidationResults((prevResults: ICreateSalesData) => ({
          ...prevResults,
          lineItems: "",
        }));
      
        setFormData((prevState: ICreateSalesData) => ({
          ...prevState,
          lineItems: items.map((item) => ({
            ...item,
            amount: (item?.rate ?? 0) * (item?.quantity ?? 0),
          })),
        }));
      
        const totalAmount = items.reduce(
          (sum, item) => sum + (item.quantity ?? 0) * (item.rate ?? 0),
          0
        );
        setTotal(totalAmount);
      }, [items]);
      
    
      const handleEditItem = (item: ItemInput) => {
        setEditItem(item);
        setIsEdit(true);
        setIsOpen(true);
      };
  return (
    <div className="flex flex-col items-center gap-4 py-4">
    <div className="w-full border-b">
      {/* Render added items */}
      {items.length > 0 
      &&items.map((item, index) => (
        <div key={item.id} className="flex justify-between items-center  py-3">
          <div>
            <p className="font-medium">{item.name}</p>
            <p className="text-sm text-gray-500">
              {item.quantity ?? 0} x  {(item.rate ?? 0).toLocaleString()}
            </p>
          </div>
          <div className="text-right ">
            <p>₦{((item.quantity ?? 0) * (item.rate ?? 0)).toLocaleString()}</p>
            <button className="text-[#044E97] font-semibold text-16 mt-4" onClick={() => handleEditItem(item)}>
              Edit
            </button>
          </div>
        </div>
      ))}

      {/* Validation Error */}
      {validationResults.lineItems && (
        <p className="text-red-600 text-sm mt-2">{validationResults.lineItems}</p>
      )}

      {/* Add New Item Button */}
      <button
        className="border border-gray-300 w-full py-3 px-4 rounded-md mt-3 flex items-center justify-center"
        onClick={() => {
          setEditItem(undefined);
          setIsEdit(false);
          setIsOpen(true);
        }}
      >
        Add new item
      </button>

    </div>

    {/* Conditionally render modal based on isOpen */}
    {isOpen && (
      <AddItem
        onSave={(newItems) => {
          if (isEdit && editItem) {
            setItems((prev) =>
              prev.map((item) =>
                item.id === editItem.id ? { ...newItems[0] }  : item
              )
            );
          } else {
            setItems([...items, ...newItems]); // Append new items when adding
          }
          setIsOpen(false);
        }}
        setIsOpen={setIsOpen}
        editItem={editItem}
        setEditItem={setEditItem}
        isEdit={isEdit}
        deleteOldData={() =>
          setItems((prevItems) => prevItems.filter((item) => item.id !== editItem?.id))
        }
        setIsEdit={setIsEdit}
      />
    )}
  </div>
  )
}

export default MobileFreeForm
